import { IconSvg, IconSvgProps } from "./icon"

export default function Link(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m10.714 7.007 1.883-1.882a4.546 4.546 0 0 1 6.428 6.428l-1.882 1.883m-3.857 3.857-1.883 1.882a4.546 4.546 0 0 1-6.428-6.428l1.882-1.883m7.714-1.285L9.43 14.722" />
    </IconSvg>
  )
}
